export const updateLifetimeAllowanceSteppersMap = {
    updateLifetimeAllowanceDetail:"Lifetime allowance details",
    updateLifetimeAllowanceConfirmation:"Confirmation",
};

export const UpdateLifetimeAllowanceContent = {
    ltaDetails: "Lifetime allowance details",
    ltaPreviouslyCrystallisedOnPlatform:"Lifetime allowance (LTA) previously crystallised on platform",
    ltaUsedByBenefitsThatCommencedPriorToDate:"LTA used by benefits that commenced prior to 06/04/2006",
    ltaCrystallisedOffPlatform:"LTA crystallised off platform not including transfers already made to the platform",
    ltaUsed:"Lifetime allowance used",

    messages:{
        percentageOver100:"The total lifetime allowance used must not exceed 100%",
        percentageUnder0: "At least 0%"
    }
}